import Styled from 'styled-components';

export const DeactivatedUsers = Styled.div`
	opacity: 0.5;
`;
